/**
 * An agent can delete a task photo they uploaded.
 * Homeowner photos stay on the task. A photo saved before uploaded_by
 * was recorded can be removed by the agent who owns the project.
 */

function agentCanRemoveTaskPhoto(photo, profileId, projectAgentId) {
  if (!photo || String(photo.uploaded_by_role) !== 'agent') return false;
  if (!profileId) return false;
  if (photo.uploaded_by) return String(photo.uploaded_by) === String(profileId);
  return Boolean(projectAgentId) && String(projectAgentId) === String(profileId);
}

module.exports = {
  agentCanRemoveTaskPhoto,
};
